import React from "react";
import "./style.css";
import Skeleton from "react-loading-skeleton";

const HeadingOfEvent = ({ title, eventLoader }) => {
  return (
    <>
      <h1 className="heading_of_event">
        {" "}
        {eventLoader === true ? (
          <Skeleton
            count={1}
            style={{ "--base-color": "#ccc", "--highlight-color": "#f5f5f5" }}
            height={40}
            inline
            width={150}
          />
        ) : (
          title
        )}
      </h1>
    </>
  );
};

export default HeadingOfEvent;
